import {
    useEffect,
    useState,
} from 'react';
import {SyntheticUsersFilter} from '../types';

// Module-scoped filter store (global-filter-store-pattern) — the Filter button with
// its active-count badge, the drawer and the list hook must observe one filter.
//
// SyntheticUsersFilterInput supports { personaId, lifecycleStage, state }.
// No default filter is seeded — in particular TOMBSTONED users are NOT filtered out
// by default. Hiding them would undermine the one thing that separates synthetic
// activity from organic activity (FNP-848).
let globalFilters: SyntheticUsersFilter = {};
const filterListeners: Set<(filters: SyntheticUsersFilter) => void> = new Set();

const notifyFilterChange = (filters: SyntheticUsersFilter) => {
    globalFilters = filters;
    filterListeners.forEach(listener => listener(filters));
};

export const useSyntheticUsersFilter = () => {
    const [filters, setFilters] = useState<SyntheticUsersFilter>(globalFilters);

    useEffect(() => {
        const listener = (newFilters: SyntheticUsersFilter) => {
            setFilters(newFilters);
        };
        filterListeners.add(listener);
        setFilters(globalFilters);
        return () => {
            filterListeners.delete(listener);
        };
    }, []);

    const handleSetFilters = (newFilters: SyntheticUsersFilter) => {
        const clean = Object.entries(newFilters)
                            .reduce((acc: Record<string, string>, [key, value]) => {
                                if (typeof value === 'string' && value.trim() !== '') {
                                    acc[key] = value.trim();
                                }
                                return acc;
                            }, {});
        notifyFilterChange(clean);
    };

    const handleClearFilters = () => {
        notifyFilterChange({});
    };

    return {
        filters,
        activeCount: Object.keys(filters).length,
        handleSetFilters,
        handleClearFilters,
    };
};
